export * from './placeholder'
export * from './lazyload'
export * from './sns'
export * from './loadStatus'
export * from './apiPath'
export * from './error'
export * from './taxRate'

export const APP_PATH_REGEX = {
  SEARCH: /^\/search/
}

export enum APP_EVENTS {
  SEARCH_KEYWORD_APPLY = 'search_keyword_apply',
  UPDATE_FAVORITES_COUNT_BADGE = 'update_favorites_count_badge',
  UPDATE_FAVORITES_STATUS = 'update_favorites_status',
  SHOW_PRODUCT_RECOMANDATION = 'show_product_recomandation'
}

export const KEY_CODES = {
  UP: 38,
  DOWN: 40
}

export const INITIAL_SCALE = 1
// minimum times user can zoom out from initial scale
export const MIN_ZOOM_LEVEL = 0
// maximum times user can zoom in from initial scale
export const MAX_ZOOM_LEVEL = 4
export const ZOOM_LEVEL = 0.125

export const SELECTION_PATHS = ['products', 'cart', 'orders', 'checkout']

export const MOBILE_SCREEN_SIZE = 768

export const FILE_EXTENSIONS = ['ai','png','pdf','jpeg','psd']

export const SERVICE_COLOR = '#0264BF'
